import React from "react";
var __jsx = React.createElement;
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { getAppointmentDateParts } from "./appointment-date-parts";
import { getAppointmentStatusClasses } from "./get-appointment-status-classes";
import { LabeledField } from "./labeled-field";
/** Appointment card with a date box on the left and a labeled six-field grid on the right. */
export function AppointmentItem(_ref) {
  var startTime = _ref.startTime,
    status = _ref.status,
    appointmentType = _ref.appointmentType,
    practitioners = _ref.practitioners,
    serviceCategory = _ref.serviceCategory,
    location = _ref.location,
    reason = _ref.reason,
    description = _ref.description,
    serviceType = _ref.serviceType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getAppointmentDatePa = getAppointmentDateParts(startTime),
    day = _getAppointmentDatePa.day,
    month = _getAppointmentDatePa.month,
    year = _getAppointmentDatePa.year,
    time = _getAppointmentDatePa.time;
  var reasonText = reason || description;
  var statusClasses = getAppointmentStatusClasses(status);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 flex-1 min-w-0 bg-sds-base-default rounded-sds-300 px-4 py-4 my-1 mr-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-4 items-start w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center shrink-0 self-stretch w-16 rounded-sds-200 border text-center py-2 gap-0.5 ".concat(statusClasses)
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-heading-main text-sds-brand-default"
  }, day), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-secondary"
  }, month, " ", year), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-base-tertiary"
  }, time)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 w-full min-w-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 w-full"
  }, /*#__PURE__*/React.createElement(LabeledField, {
    label: t("appointment_type"),
    value: appointmentType
  }), /*#__PURE__*/React.createElement(LabeledField, {
    label: t("label.provider_optional_multiple"),
    value: practitioners
  }), /*#__PURE__*/React.createElement(LabeledField, {
    label: t("service_category"),
    value: serviceCategory
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 w-full"
  }, /*#__PURE__*/React.createElement(LabeledField, {
    label: t("location"),
    value: location
  }), /*#__PURE__*/React.createElement(LabeledField, {
    label: t("reason_for_exam"),
    value: reasonText
  }), /*#__PURE__*/React.createElement(LabeledField, {
    label: t("service_type"),
    value: serviceType
  })))), description && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPencil,
    className: "w-3.5 h-3.5 shrink-0 text-sds-brand-default"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, description)));
}